var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-6.000000, -29.000000)",
    stroke: "#B7844D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(18.500000, 41.500000) rotate(-45.000000) translate(-18.500000, -41.500000) translate(10.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: -7.20386129e-15,
    x2: 8.5,
    y2: 17,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3.68294017e-14,
    y1: 8.5,
    x2: 17,
    y2: 8.5,
    id: "Stroke-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.718a0b3f087df3b01c6fb51ac6f2ff1c.svg";
export { ForwardRef as ReactComponent };